import type { WorkDays } from './types';

interface SlotBuckets {
  morning: string[];
  afternoon: string[];
  evening: string[];
}

export function getSlotsForDate(
  dateStr: string,
  providerWorkDays: WorkDays,
  intervalMinutes: number
): SlotBuckets {
  const d = new Date(dateStr + 'T12:00:00');
  const DOW_NAMES = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  const dow = DOW_NAMES[d.getDay()];
  const ranges = providerWorkDays[dow] || [];
  const slots: SlotBuckets = { morning: [], afternoon: [], evening: [] };

  const parseTime = (str: string): number | null => {
    const s = str.trim();
    const m12 = s.match(/^(\d+):(\d+)\s*(am|pm)$/i);
    if (m12) {
      let h = parseInt(m12[1], 10);
      const min = parseInt(m12[2], 10);
      const ap = m12[3].toLowerCase();
      if (ap === 'pm' && h !== 12) h += 12;
      if (ap === 'am' && h === 12) h = 0;
      return h * 60 + min;
    }
    const m24 = s.match(/^(\d{1,2}):(\d{2})$/);
    if (m24) return parseInt(m24[1], 10) * 60 + parseInt(m24[2], 10);
    return null;
  };

  const fmtTime = (totalMins: number): string => {
    const h = Math.floor(totalMins / 60);
    const m = totalMins % 60;
    const ampm = h >= 12 ? 'pm' : 'am';
    const hh = h > 12 ? h - 12 : (h === 0 ? 12 : h);
    return `${hh}:${String(m).padStart(2, '0')} ${ampm}`;
  };

  const allMins = new Set<number>();
  for (const range of ranges) {
    const startMins = parseTime(range.start);
    const endMins = parseTime(range.end);
    if (startMins === null || endMins === null) continue;
    let t = startMins;
    while (t <= endMins) {
      allMins.add(t);
      t += intervalMinutes;
    }
  }

  const sorted = [...allMins].sort((a, b) => a - b);
  for (const t of sorted) {
    const label = fmtTime(t);
    const h = Math.floor(t / 60);
    if (h < 12) slots.morning.push(label);
    else if (h < 17) slots.afternoon.push(label);
    else slots.evening.push(label);
  }

  return slots;
}
